enum LanguageCode {
  AR = 'ar-ar',
  EN = 'en-us',
  FR = 'fr-fr',
  IN = 'id',
  IT = 'it-it',
  ES = 'es-es',
  TH = 'th',
  DE = 'de-de',
  ZH = 'zh-cn',
  VI = 'vi-vn'
}

export default LanguageCode;
